<template>
        <v-sheet 
            color="secondary"
            max-width="600">
            <v-sheet class="mt-5"> 
                <FailureTable  
                    ref="FailureTable" 
                    @delete="handelDelete" 
                    :deleteLoading="deleteLoading" 
                    @loading="handelLoading"
                />
            </v-sheet>    
            <v-row class="ma-1 mt-2">
                <v-col>
                    <v-btn
                        small
                        fab
                        color="primary"
                        @click="openfailureAddDialog"
                        :disabled="loading">

                        <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-dialog
                >
                <FailureAddDialog ref="failureAddDialog" :title="title" v-model="display" @addedRecord="handelAddedRecord" @done="handelDone" @cancel="handelCancel"/>
            </v-dialog>
            <DeleteDesisionDialog v-model="ShowDeleteDialog" @yes="handelYes" @no="handelNo" />
            <MalfactionNotification :value.sync="snakebar.successNotification" :text="snakebar.text" :color="snakebar.color"/>
        </v-sheet>
</template>

<script>
import FailureAddDialog from './FailureAddDialog'
import FailureTable from "./FailureTable"
import {deleteMalfaction} from "../services/malfactions"
import DeleteDesisionDialog from "./DeleteDesisionDialog.vue"
import MalfactionNotification from "./MalfactionNotification.vue"
export default {
    components: {FailureTable, FailureAddDialog, DeleteDesisionDialog, MalfactionNotification},
    data() {
        return {
            failures: [
    
            ],
            loading: false,
            display: false,
            title: "",
            loadingAdd: false,
            ShowDeleteDialog: false,
            deleteId: null,
            deleteLoading: null ,
            snakebar: {
                successNotification: false,
                text: '',
                color:''
            }
        }
    },
    methods: {
        openfailureAddDialog() {
            this.display = true
            this.title = this.$t("ADD_NEW_FAILURE" );

        },
        handelAddedRecord(val) {
            this.$refs.FailureTable.addNewRecord(val)
        },
        handelDone() {
            this.display = false
        },
        handelDelete(id) {           
            this.deleteId = id
            this.ShowDeleteDialog = true
        },
        handelYes(){
            this.delete(this.deleteId)
            this.ShowDeleteDialog = false
            
        },
        async delete(id) {
            try{
                await deleteMalfaction(id)
                this.$refs.FailureTable.deleteFailure(id)
                this.deleteId = null
                this.deleteLoading = Math.random()
                this.snakebar = {
                   successNotification: true,
                    text: this.$t("has_been_deleted"),
                    color:'success' 
                }
            }catch(error) {
                let message = error.response ? error.response.data.message : error
                this.setErrors(message)
            }
        },
        handelNo() {
            this.ShowDeleteDialog = false
            this.deleteLoading = Math.random()
        },
        handelLoading(val) {
            this.loading = val
        },
        handelCancel() {
            this.display = false
        },
        setErrors(message) {
            this.snakebar = {
                successNotification : true,
                text : message,
                color : "error"
            }
        }
    }
}
</script>

<style>

</style>